import React from "react";
import { ContactDetails, ChatContactSample } from "../../../../../assets/images";
import PropTypes from "prop-types";
import { isArray as _isArray } from "lodash";
const ContactComponent = (props = {}) => {
  const { messageObject = {}, toggleContactPopup } = props;
  const { msgBody: { contact: { name = "" , phone_number = ""} = {} } = {} } = messageObject;
   const updatePhone = _isArray(phone_number) ? phone_number.join("\n") : phone_number;
  return (
    <div className="contact-message-block" onClick={toggleContactPopup}>
      <div className="contact-message-inner">
        <div className="contact">
          <img src={ChatContactSample} alt="" />
        </div>
        <div className="contact-text">
          <p className="name">{name}</p>
          <span className="contact_number">{updatePhone}</span>
        </div>
      </div>
    </div>
  );
};

export default ContactComponent;

ContactComponent.propTypes = {
  messageObject: PropTypes.shape({
    msgBody: PropTypes.shape({
      contact: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
  }),
  toggleContactPopup: PropTypes.func,
};